import {capitalizeFirstLetters} from "../../misc/helpers";
import {getSelectedFiltersLength} from "../../misc/filtersFunctions";

const changeMaterialToColorArray = ["vanity_faucet", "paper_holder", "robe_hook", "towel_bar", "towel_ring",
  "bathtub_body", "vanity_console", "replacement_tub", "bathtub_fixture", "vanity_ptrap", "vanity_legs", "vanity_middle",
  "toilet", "vanity_ws_towel_bar", "vanity_washstand", "vanity_cabinet"];

/**
 * updated Names per Lixil requirements
 * @param filterGroup {filterGroupInterface}
 * @param partId {string}
 * @returns {string|null}
 */
export const getHardCodedFilterGroupName = (filterGroup, partId = "") => {
  switch (filterGroup.name) {
    case "Material": {
      if (changeMaterialToColorArray.includes(partId)) {
        return "Color"
      }
      break;
    }
    case "GPF_Max": {
      return "GPF"
    }
    case "LixilProductSubCategory": {
      switch (partId) {
        case "vanity_faucet":
        case "bathtub_fixture":
          return "Faucet Type"
        default:
          break;
      }
    }
  }
  return (filterGroup.name || "").replace(/_/gi, " ")
}

/**
 * filters hardcode LX-827 - LX-839 tasks in Jira
 * @param filterGroup {filterGroupInterface}
 * @param partId {string}
 * @returns {boolean}
 */
export const weShouldHideFilterGroup = (filterGroup, partId) => {
  switch ((filterGroup.name || "").trim()) {
    case "Product_Width":
    case "LixilProductCategory":
    case "LixilProductSuperCategory":
    case "Bath_Accessory_Mount_Type":
    case "Designer Recommended":
    case "EA_Each_Weight":
    case "Small_Parcel_Postable_SAP_YN":
    case "Volume_SAP":
    case "Bath_Accessory_No_of_Hooks":
    case "Bath_Accessory_No_of_Bars":
    case "Fitting_Mount_Type":
    case "Fitting_Handle_Type":
    case "ADA_YN":
    case "Fitting_Touchless_Touch_On":
    case "Product_Height":
    case "Faucet_Type_from_Classification":
    case "Product_Length":
    case "Tub_Product_Type":
    case "Bath_Therapy_Type":
    case "Drain_Location":
    case "Hand_Shower_Included_YN":
    case "Rough_In_Size":
    case "Toilet_Type_from_Classification":
    case "Fitting_No_of_Holes_Required":
      return true
    case "Color": {
      return changeMaterialToColorArray.includes(partId);
    }
    case "Brand": {
      switch (partId) {
        case "vanity_console":
        case "vanity_ptrap":
        case "vanity_cabinet":
        case "vanity_legs":
        case "vanity_middle":
        case "vanity_ws_towel_bar":
        case "vanity_washstand":
          return true
        default:
          return false
      }
    }
    case "Collection": {
      switch (partId) {
        case "vanity_ptrap":
        case "vanity_legs":
        case "vanity_middle":
          return true
        default:
          return false
      }
    }
    case "Size":
    case "Manufacturer": {
      switch (partId) {
        case "vanity_cabinet":
          return true
        default:
          return false
      }
    }
    case "LixilProductSubCategory": {
      switch (partId) {
        case "vanity_faucet":
        case "bathtub_fixture":
          return false
        default:
          return true
      }
    }
    default:
      return false
  }
}

/**
 * filters hardcode LX-827 - LX-839 tasks in Jira
 * @param filterValue {filterValueInterface}
 * @returns {boolean}
 */
export const weShouldHideFilterValue = (filterValue) => {
  // console.log("filterValue", filterValue);
  return (filterValue.id === 10446 && filterValue.value === "Town Square® S")
    || (filterValue.id === 10415 && filterValue.value === "Cadet®")
    || (filterValue.id === 10445 && filterValue.value === "Princeton™")
    || (filterValue.id === 10448 && filterValue.value === "Colony®")
    || (filterValue.id === 10416 && filterValue.value === "Eurocube®")
    || (filterValue.id === 10410 && filterValue.value === "Concetto™")
    || (filterValue.id === 9950 && filterValue.value === "LINEARE™")
}

/**
 * filters hardcode LX-827 - LX-839 tasks in Jira
 * @param filterGroups {[filterGroupInterface]}
 * @param partId {string}
 * @param selectedFilters {array}
 * @returns {[filterGroupInterface]}
 */
export const getHardCodedFilterGroups = (filterGroups, partId, selectedFilters) => {
  return filterGroups
    .filter(filterGroup => !weShouldHideFilterGroup(filterGroup, partId))
    .map(filterGroup => {
      const selectedFiltersLength = getSelectedFiltersLength(filterGroup, selectedFilters);
      const filterGroupName = getHardCodedFilterGroupName(filterGroup, partId);
      filterGroup.values = filterGroup.values.sort((a, b) => a.id - b.id);
      return Object.assign({}, filterGroup, {filterGroupName, selectedFiltersLength})
    })
    .sort((a, b) => a.id - b.id);
}


/**
 * updated Names per Lixil requirements
 * @param filterValue {filterValueInterface}
 * @returns {string}
 */
export const getFixedFilterValueName = (filterValue) => {
  switch (filterValue.value) {
    // case "StarLight Chrome":
    // case "Starlight Chrome":
    // case "Starlight chrome":
    //   return window.location.href.includes("grohe") ? "Starlight Chrome" : "Polished Chrome"
    case "Grohe":
    case "grohe":
      return "GROHE"
    case "Centerset Bathroom Faucets":
      return "Centerset"
    case "Single Hole Bathroom Faucets":
      return "Single Hole"
    case "Widespread Bathroom Faucets":
      return "Widespread"
    case "Vessel Bathroom Faucets":
      return "Vessel"
    default:
      return capitalizeFirstLetters(filterValue.displayText || filterValue.value || "")
        .replace(/_/gi, " ")
  }
}
